import React, { useMemo, useState, useRef, useEffect, CSSProperties } from 'react';
// import SearchIcon from '/icons/general-icons/search.svg?jsx';
import { countryPhones } from './constants';
// import { MenuItemWrapper } from './Menu/MenuItem';
import { PrefixData } from './model';
import CountryIcon from './CountryIcon';
import { useTranslation } from 'react-i18next';

// function useClickAway(
//     ref: React.RefObject<HTMLElement>,
//     handler: (event: MouseEvent | TouchEvent) => void
// ) {
//     useEffect(() => {
//         function handleClick(event: MouseEvent | TouchEvent) {
//             // Якщо нема current — нічого не робимо
//             if (!ref.current) return;
//             // target може бути і null або window (не завжди Node)
//             if (
//                 event.target instanceof Node &&
//                 !ref.current.contains(event.target)
//             ) {
//                 handler(event);
//             }
//         }
//         document.addEventListener('mousedown', handleClick);
//         document.addEventListener('touchstart', handleClick);
//         return () => {
//             document.removeEventListener('mousedown', handleClick);
//             document.removeEventListener('touchstart', handleClick);
//         };
//     }, [ref, handler]);
// }



type PrefixPopperProps = {
    onClose: () => void;
    onChange: (phone: PrefixData) => void;
};

const styles: { [key: string]: CSSProperties } = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 6,
        border: '1px solid #EAEAEB',
        background: '#fff',
        maxHeight: 188,
        overflow: 'auto',
        position: 'relative',
    },
    searchFieldWrapper: {
        display: 'flex',
        padding: '8px 12px 8px 16px',
        alignItems: 'center',
        gap: 8,
        position: 'sticky',
        top: 0,
        background: '#fff',
        borderBottom: '1px solid #EAEAEB',
    },
    countriesList: {
        display: 'flex',
        flexDirection: 'column',
        margin: 0,
        padding: 0,
        listStyle: 'none',
    },
    countryItem: {
        padding: '4px 12px 4px 16px',
        fontSize: 12,
        height: 36,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        border: 'none',
        background: 'none',
    },
    countryItemActive: {
        background: '#F6F6F6',
    },
    searchField: {
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 500,
        outline: 'none',
        border: 'none',
        flex: 1,
    },
    countryName: {
        color: '#999',
        marginLeft: 8,
    },
};

const PrefixPopper: React.FC<PrefixPopperProps> = ({ onClose, onChange }) => {
    const { t } = useTranslation();
    const [selectedPrefix, setSelectedPrefix] = useState<string>('');
    const [searchQuery, setSearchQuery] = useState<string>('');
    const wrapperRef = useRef<HTMLDivElement>(null);

    // useClickAway(wrapperRef, onClose);

    const filteredList = useMemo(() => {
        return countryPhones.filter((country) => {
            return JSON.stringify(country)
                .toLocaleLowerCase()
                .includes(searchQuery.toLocaleLowerCase());
        });
    }, [searchQuery]);

    const handlePhoneSelect = (prefixData: PrefixData) => {
        console.log('Prefix selected:', prefixData); // <-- LOG PREFIX HERE
        onChange(prefixData);
        setSelectedPrefix(prefixData.prefix);
        onClose();
    };

    useEffect(() => {
        console.log('filteredList', filteredList); // Подивишся які країни відфільтровані
    }, [filteredList]);

    return (
        <div ref={wrapperRef} style={styles.wrapper}>
            <div style={styles.searchFieldWrapper}>
                {/* <SearchIcon /> */}
                <input
                    style={styles.searchField}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder={`${t('8615')}...`}
                />
            </div>
            <ul style={styles.countriesList}>
                {filteredList.map(({ prefix, flag, name }) => (
                    <li
                        key={prefix}
                        style={{
                            ...styles.countryItem,
                            ...(prefix === selectedPrefix ? styles.countryItemActive : {}),
                        }}
                        onClick={() => handlePhoneSelect({ prefix, flag, name })}
                    >
                        <CountryIcon flag={flag} />
                        <div style={{ marginLeft: 8 }}>{prefix}</div>
                        <span style={styles.countryName}>{name}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PrefixPopper;
